module.exports = "/v2/pages/dashboard/dist/1896786ae2d42af6f9aaac1006321f9d.svg";